/** In-place canvas color filters for the image document editor. */

export const FILTER_MODES = {
    ORIGINAL: 'original',
    GRAYSCALE: 'grayscale',
    BLACK_WHITE: 'bw',
};

const luminance = (data, i) =>
    0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];

export function applyGrayscale(canvas) {
    const ctx = canvas.getContext('2d');
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;
    for (let i = 0; i < data.length; i += 4) {
        const y = luminance(data, i);
        data[i] = y;
        data[i + 1] = y;
        data[i + 2] = y;
    }
    ctx.putImageData(imageData, 0, 0);
    return canvas;
}

/** Scanned-document look: pure black/white split at `threshold` (0-255). */
export function applyBlackWhite(canvas, threshold = 170) {
    const ctx = canvas.getContext('2d');
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;
    for (let i = 0; i < data.length; i += 4) {
        const value = luminance(data, i) > threshold ? 255 : 0;
        data[i] = value;
        data[i + 1] = value;
        data[i + 2] = value;
    }
    ctx.putImageData(imageData, 0, 0);
    return canvas;
}

export function applyFilter(canvas, mode, threshold) {
    if (mode === FILTER_MODES.GRAYSCALE) return applyGrayscale(canvas);
    if (mode === FILTER_MODES.BLACK_WHITE) return applyBlackWhite(canvas, threshold);
    return canvas;
}
